import { render } from "./ResultadoForm.vue?vue&type=template&id=26802a74&scoped=true"
import script from "./ResultadoForm.vue?vue&type=script&lang=js"
export * from "./ResultadoForm.vue?vue&type=script&lang=js"

import "./ResultadoForm.vue?vue&type=style&index=0&id=26802a74&scoped=true&lang=scss"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26802a74"]])

export default __exports__